import { render, staticRenderFns } from "./star-query-icon.vue?vue&type=template&id=603fcfca"
import script from "./star-query-icon.vue?vue&type=script&lang=js"
export * from "./star-query-icon.vue?vue&type=script&lang=js"
import style0 from "./star-query-icon.vue?vue&type=style&index=0&id=603fcfca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports